import ReactDOM from 'react-dom';

import CoreUtils from '../../common/utils/CoreUtils';
import ReactUtils from '../../common/utils/ReactUtils';

const toolTipContentId = 'scheduleMainToolTipId';

export default class ScheduleToolTipController {
  constructor(tooltipRef) {
    this.tooltipRef = tooltipRef;

    this.activeToolTipElement = null;
    this.activateTimeout = null;
    this.deactivateTimeout = null;
  }

  dispose() {
    this.cancelActivateTimeout();
    this.cancelDeactivateTimeout();

    var tooltip = this.resolveTooltip();
    if (tooltip !== null)
      tooltip.dispose();

    this.activeToolTipElement = null;
  }

  resolveTooltip() {
    return ReactUtils.resolveReference(this.tooltipRef);
  }

  activate(element, contentRender, position, delay) {
    this.cancelDeactivateTimeout();

    if (element === this.activeToolTipElement)
      return;

    if (this.activeToolTipElement !== null || CoreUtils.isUndefinedOrNull(delay))
      this.activateInternal(element, contentRender, position);
    else
      this.activateTimeout = setTimeout(this.activateInternal.bind(this), delay, element, contentRender, position);
  }

  deactivate() {
    this.cancelActivateTimeout();
    this.deactivateTimeout = setTimeout(this.deactivateInternal.bind(this), 100);
  }

  activateInternal(element, contentRender, position) {
    this.activateTimeout = null;

    if (!element.isConnected)
      return;

    var toolTip = this.resolveTooltip();
    if (toolTip === null || contentRender === null)
      return;

    this.activeToolTipElement = element;

    ReactDOM.render(contentRender, document.getElementById(toolTipContentId));

    toolTip.option('position', position);
    toolTip.show(element);
  }

  deactivateInternal() {
    this.deactivateTimeout = null;

    var tooltip = this.resolveTooltip();
    if (tooltip !== null)
      tooltip.hide();

    this.activeToolTipElement = null;
  }

  cancelActivateTimeout() {
    if (this.activateTimeout === null)
      return;

    clearTimeout(this.activateTimeout);
    this.activateTimeout = null;
  }

  cancelDeactivateTimeout() {
    if (this.deactivateTimeout === null)
      return;

    clearTimeout(this.deactivateTimeout);
    this.deactivateTimeout = null;
  }

  render() {
    return (<div id={toolTipContentId} />);
  }
}